import React from "react";
import cn from "classnames";
import styles from "./Overview.module.sass";
import { pb } from "../../../../../services/pocketbase";

const Overview = ({ documentData, isProspect = false }) => {
  // Debug : afficher les données reçues
  console.log('DocumentData dans Overview:', documentData);
  
  if (!documentData) {
    return <div className={styles.noDocument}>Aucun document disponible</div>;
  }
  
  // Déterminer la collection selon le type de document
  const collectionName = isProspect ? 'prospect_documents' : 'student_documents';

  // Construction du titre
  const fileName = documentData.file ? documentData.file.split('/').pop() : null;
  const title = documentData.type ? 
    (fileName ? `${documentData.type} - ${fileName}` : documentData.type) : 
    (fileName || "Document sans titre");

  // Construction de la date
  const dateStr = documentData.created || documentData.updated || documentData.date || null;
  const formattedDate = dateStr ? new Date(dateStr).toLocaleDateString('fr-FR', { 
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }) : "Date non disponible";

  // Fonction pour construire l'URL du fichier
  const getFileUrl = (document) => {
    if (!document || !document.file) return null;
    return `${pb.baseUrl}/api/files/${collectionName}/${document.id}/${document.file}`;
  };

  // Fonction pour déterminer le type de fichier (identique à StudentDetail)
  const getFileType = (fileName) => {
    if (!fileName) return 'unknown';
    
    const ext = fileName.split('.').pop().toLowerCase();
    
    if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(ext)) {
      return 'image';
    } else if (ext === 'pdf') {
      return 'pdf';
    } else {
      return 'other';
    }
  };
  
  // Fonction pour retourner l'icône appropriée (identique à StudentDetail)
  const getFileIcon = (fileName) => {
    if (!fileName) return '/images/content/file-document.svg';
    
    const ext = fileName.split('.').pop().toLowerCase();
    
    if (['pdf'].includes(ext)) {
      return '/images/content/file-pdf.svg';
    } else if (['doc', 'docx'].includes(ext)) {
      return '/images/content/file-doc.svg';
    } else if (['xls', 'xlsx'].includes(ext)) {
      return '/images/content/file-xls.svg';
    } else {
      return '/images/content/file-document.svg';
    }
  };
  
  // Fonction pour rendre la prévisualisation (identique à StudentDetail)
  const renderPreview = (document) => {
    const fileUrl = getFileUrl(document);
    if (!fileUrl) {
      return <img src="/images/content/file-document.svg" alt="Document sans fichier" />;
    }
    
    const fileType = getFileType(document.file);
    
    if (fileType === 'image') {
      return (
        <div className={styles.imagePreview}>
          <img src={fileUrl} alt={document.type || 'Image'} />
        </div>
      );
    } else if (fileType === 'pdf') {
      return (
        <div className={styles.pdfPreview}>

          <iframe
            src={`${fileUrl}#view=FitH&zoom=100`}
            width="100%"
            height="900px"
            style={{ border: 'none', minHeight: '600px' }}
            title="Aperçu PDF"
          >
            <p>
              Votre navigateur ne supporte pas l'affichage des PDFs. 
              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                Cliquez ici pour télécharger le PDF
              </a>
            </p>
          </iframe>
        </div>
      );
    } else {
      return <img src={getFileIcon(document.file)} alt={document.type || 'Document'} />;
    }
  };
  
  return (
    <div className={styles.overview}>
      {/* Titre du document */}
      <div className={cn("h4", styles.title)}>{title}</div>
      
      {/* Date de dépôt */}
      <div className={styles.info}>
        Déposé le {formattedDate}
      </div>
      
      {/* Prévisualisation */}
      <div className={styles.gallery}>
        <div className={styles.preview}>
          {renderPreview(documentData)}
        </div>
      </div>
    </div>
  );
}

export default Overview;
